/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedBlurbUrgency_item$ref: FragmentReference;
export type PdpSharedBlurbUrgency_item = {|
  +urgency: ?{|
    +pdpBlurbDisplayInfo: ?{|
      +key: ?string,
      +displayTitle: ?string,
      +displaySubtitle: ?string,
    |}
  |},
  +$refType: PdpSharedBlurbUrgency_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbUrgency_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "urgency",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId",
          "type": "String"
        }
      ],
      "concreteType": "Urgency",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pdpBlurbDisplayInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PdpBlurbDisplayInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "key",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "displayTitle",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "displaySubtitle",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'afd23175263753bf14341c466103cf46';
module.exports = node;
